import React from 'react';
import styles from './Alert.module.css';

const variants = {
  info: styles.info,
  success: styles.success,
  warning: styles.warning,
  danger: styles.danger,
};

export default function Alert({ children, variant = 'info', className = '', dismissible, onDismiss, ...rest }) {
  return (
    <div className={`${styles.alert} ${variants[variant] || styles.info} ${className}`} {...rest}>
      <div className={styles.content}>{children}</div>
      {dismissible && (
        <button className={styles.dismiss} onClick={onDismiss} aria-label="Dismiss">
          &times;
        </button>
      )}
    </div>
  );
}
